import { useEffect } from 'react';

export const useScrollLock = (isLocked: boolean) => {
    useEffect(() => {
        if (isLocked) {
            // 스크롤바 너비 계산
            const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
            
            // 스크롤 막기 + 패딩으로 레이아웃 시프트 방지
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = `${scrollBarWidth}px`;
        }
        
        // 컴포넌트 언마운트 시 스크롤 복원
        return () => {
            document.body.style.overflow = 'unset';
            document.body.style.paddingRight = '0px';
        };
    }, [isLocked]);
};
